/**
 * Guide Me demo-content constants.
 *
 * Guide Me tours no longer seed data into the user's own active project.
 * Every tour now runs against the organization's Sample Project, whose full
 * canonical catalog (release folder, test cases, cycle, requirements,
 * defects, UI element, test data profile, automated cycle) is guaranteed to
 * already exist by the backend before the tour ever opens — see
 * `GuideTourProvider`'s call to `startGuideMePreview`, which silently
 * switches the active project to Sample Project and (re-)runs the backend's
 * idempotent seeder (`orgSampleProjectService.seedSampleContent`) first.
 *
 * The constants below are ONLY used as prefill values for the handful of
 * "teach-by-creating" tour steps (create-cycle, create-test-case,
 * reusable-elements, test-data-profiles, requirements-coverage,
 * defect-workflow) where the user performs a real "Save" themselves. They are
 * deliberately distinct from the canonical Sample Project names (see
 * backend's `orgSampleProjectService.ts`) so the user's own create action
 * never collides with the pre-existing catalog.
 *
 * `create-project` is NOT part of this redesign — it still creates a real
 * project in the user's own organization, independent of Sample Project.
 */

export const GUIDE_ME_TAG = "[Guide Me]";
export const DEMO_APP_URL = "https://learningmanagement.autopilotqa.com/";
export const DEMO_PROJECT_NAME = `${GUIDE_ME_TAG} LMS Demo Project`;

// Teach-by-creating prefill values — new items the user creates themselves
// during the tour. Chosen to never collide with Sample Project's canonical
// catalog names (release folder "v1.0 — LMS Launch", cycle
// "[Guide Me] Sprint 1 — LMS Smoke Tests", the 9 canonical test cases, etc.)
export const DEMO_CYCLE_NAME = `${GUIDE_ME_TAG} Course Enrollment Sprint`;
export const DEMO_TEST_CASE_NAMES = [
  `${GUIDE_ME_TAG} Verify a student can enroll in a course`,
  `${GUIDE_ME_TAG} Verify course shows correct price, lessons and seats`,
  `${GUIDE_ME_TAG} Verify enrollment is blocked when a course is full`,
];
export const DEMO_TEST_DATA_NAME = `${GUIDE_ME_TAG} Login Data`;
export const DEMO_REQUIREMENT_NAME = `${GUIDE_ME_TAG} Course Enrollment`;
export const DEMO_DEFECT_TITLE = `${GUIDE_ME_TAG} Enroll Now button does nothing on the course page`;
